import React from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { styled } from '@uhg-abyss/web/tools/styled';

const CardContent = styled('div', {
  padding: '8px 16px 16px',
  fontSize: '15px',
  fontWeight: '400',
  lineHeight: '1.7',
  textAlign: 'justify',
});

const CardTitle = styled('div', {
  backgroundColor: '#0000',
  color: '#002677',
  fontSize: '16px',
  fontWeight: '700',
  padding: '12px ',
  marginTop: '10px',
});

export const AllCommunicationPageDesc = () => {
  return (
    <Card id="allCommunicationsCornerCard">
      <CardTitle>Communications Corner</CardTitle>
      <div>
        <CardContent>
          Welcome to Communications Corner. Here you will be able to see all the
          communications that have been sent out to your organization regarding
          any updates for all APIs that are on the API Marketplace. We encourage
          you to view them as needed. These will be available for you to view
          for 6 months after the communication has been sent out.
        </CardContent>
      </div>
    </Card>
  );
};
